/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Error';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const ErrorIcon = withMuiAdapter(Base, 'Error');
